import { ACTIONS, WHITELISTED_ITEM_DEFAULTS } from "./constants";

export const wasCustomerRemoved = (customer) => !!customer?.removedDateTime;

export const processCustomer = (rawCustomer) => {
  let processedCustomer = { ...rawCustomer };

  // Tabulator uses the first item in the list to deduce displayed columns.
  // Make sure all items have the same properties so that tabulator does not skip any.
  processedCustomer = Object.entries(WHITELISTED_ITEM_DEFAULTS).reduce(
    (accumulator, defaultEntry) => {
      const [key, defaultValue] = defaultEntry;
      accumulator[key] = processedCustomer?.[key] ?? defaultValue;
      return accumulator;
    },
    {}
  );

  processedCustomer.actions = wasCustomerRemoved(processedCustomer)
    ? [ACTIONS.RE_ADD]
    : [ACTIONS.REMOVE];
  return processedCustomer;
};

/**
 * Check if all customers in the list can have the action
 * specified performed on them.
 */
export const canPerformAction = (customers, action) => {
  if (!customers?.length) {
    return false;
  }

  return customers.every((customer) => customer.actions.includes(action));
};
